import qs from 'query-string'
import _ from 'lodash'
// import axios from 'axios'
import request from 'superagent'

const developmentBaseURL = 'http://localhost:9999'
// const productionBaseURL = 'http://188.166.215.81:9999'
const productionBaseURL = 'https://api.remeind.zugarzeeker.com'
const baseURL = process.env.NODE_ENV === 'production' ? productionBaseURL : developmentBaseURL

console.log(baseURL)

const formatQuery = (query) => {
  // TODO: delete token from localStorage (Doctor)
  const token = qs.parse(location.hash.split('?').pop()).token || localStorage.getItem('token')
  const chunks = location.hash.split('/')
  const index = _.findIndex(chunks, (o) => o === 'patients')
  let patientId = index >= 0 && chunks[index + 1]
  patientId = patientId ? `"${patientId}"` : 'null'
  const replaceText = token ? `(token: "${token}", patientId: ${patientId}, ` : '('
  return (
    query
    .split('\n')
    .join(' ')
    .split(' ')
    .filter((x) => x !== '')
    .join(' ')
    .replace('(', replaceText)
    .replace(', )', ')')
    .replace('patientId: null,  patientId:', 'patientId:')
  )
}

const client = {
  post: (url, data) => (
    request.post(url).send(data)
    .set('Content-Type', 'application/json')
    .then((res) => res.body)
  )
}

export const graphql = async (query) => {
  console.log('[query]', formatQuery(query));
  // const client = axios.create({
  //   baseURL,
  //   withCredentials: true,
  //   routes: {
  //     cors: true
  //   }
  // })
  try {
    // const response = await client.post(`/graphql`, { query: formatQuery(query) })
    const response = await client.post(`${baseURL}/graphql`, { query: formatQuery(query) })
    return response
  } catch (e) {
    if (e.response) {
      console.log('Error', e.response.data)
    }
    throw e
  }
}

export default graphql



// WEBPACK FOOTER //
// ./src/graphql.js